export * from './saved-gutachten-filters.component';
export * from './saved-gutachten-filters.component.module';